import type { BattleshipView } from '@minigame-race/contracts';
import type { MinigameProps } from '../../race/types.js';
import { BattleshipBoard } from '../../turn/BattleshipBoard.js';
import { TurnBoardFrame } from '../../turn/TurnBoardFrame.js';

/** Battleship as a race segment. See ConnectFourGame for the turn-adapter note. */
export function BattleshipGame({ view, emit }: MinigameProps) {
  const v = view as BattleshipView | null;
  if (!v) return null;
  return (
    <TurnBoardFrame>
      <BattleshipBoard view={v} yourTurn={v.yourTurn} onMove={emit} />
    </TurnBoardFrame>
  );
}
